import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PupilDuplicateState } from './pupil-duplicate.state';

export const selectPupilDuplicateState = createFeatureSelector<PupilDuplicateState>('pupilDuplicate');

export const selectPupilDuplicateGroups = createSelector(
  selectPupilDuplicateState,
  (state) => state.groups
);

export const selectPupilDuplicateLoading = createSelector(
  selectPupilDuplicateState,
  (state) => state.loading
);

export const selectPupilDuplicateLoaded = createSelector(
  selectPupilDuplicateState,
  (state) => state.loaded
);

export const selectPupilDuplicateError = createSelector(
  selectPupilDuplicateState,
  (state) => state.error
);

export const selectPupilDuplicateActionInProgressId = createSelector(
  selectPupilDuplicateState,
  (state) => state.actionInProgressId
);
